import { useDispatch } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { replace } from 'connected-react-router';

export const useRouterReplace = (): typeof replace => {
  const dispatch = useDispatch();

  return bindActionCreators(replace, dispatch);
};
